import PropTypes from 'prop-types';

import {v4 as uuidv4} from 'uuid';

import * as cliparts from 'assets/cliparts';
import {Group, loadSVGFromString, util} from 'fabric';

import {isCustom, limitReached, setLastObjectActive} from '../canvas-helper';

import {createPlayerName, createPlayerNumber, getNextPlayerNumber, getPlayerSizeOptions} from './player-utils';

const Player = ({canvas, clipart, colors, size}) => {

    canvas.on({
        'mouse:down': (o) => {
            if (limitReached(canvas)) {
                return;
            }

            // If clicking on an existing player, just select it instead of creating a new one
            if (o.target && o.target.custom?.type === 'player') {
                canvas.setActiveObject(o.target);
                canvas.renderAll();
                return;
            }

            if (canvas.getActiveObject()) {
                if (isCustom(canvas.getActiveObject())) {
                    return;
                }

                canvas.discardActiveObject();
            }

            const pointer = canvas.getScenePoint(o.e);
            const nextNumber = getNextPlayerNumber(canvas, colors.name).toString();

            createPlayer(canvas, clipart, colors, size, pointer.x, pointer.y, nextNumber, {},
                (canvas, group) => {
                    canvas.add(group);
                    setLastObjectActive(canvas);
                });
        },
    });
};

Player.propTypes = {
    canvas: PropTypes.object.isRequired
};

export const createPlayer = (canvas, clipart, colors, size, posX, posY, playerNumber, customData, onComplete, playerName = '') => {
    loadSVGFromString(cliparts[clipart]).then(({objects}) => {

        let img = util.groupSVGElements(objects);
        const playerSize = getPlayerSizeOptions(size);

        img.scaleToWidth(playerSize.size, false);
        //img.scaleToWidth(90, false);
        // duotone SVGs have two paths
        const svgObjects = img.getObjects();
        svgObjects[0].set('fill', colors.value1);
        svgObjects[0].set('opacity', 1);
        svgObjects[1].set('fill', colors.value2);
        svgObjects[1].set('opacity', 1);
        // would work, but not ideal
        // svgObjects[0].set('shadow', {color: '#000000', blur: 10, offsetX: 0, offsetY: 0});
        // draw black border, causes some display problems
        // svgObjects[2].set('fill', '#000000');
        // svgObjects[2].set('strokeWidth', 8);
        img.set({
            originX: 'center',
            originY: 'center',
            left: 0,
            top: 0
        });
        img.hasBorders = false;
        // cacheProperties used to set dirty flag(triggering re-render) on property change - currently not needed
        // img.item(0).cacheProperties = fabric.Object.prototype.cacheProperties.concat('fill', 'opacity');
        // img.item(1).cacheProperties = fabric.Object.prototype.cacheProperties.concat('fill', 'opacity');

        const textSize = 28 + size;
        const number = createPlayerNumber(playerNumber.toString(), colors.textColor, textSize);
        
        console.log('[createPlayer] playerName:', playerName);
        
        // Create the group elements array
        const groupElements = [img, number];
        
        // Add player name if provided
        if (playerName) {
            const nameText = createPlayerName(playerName, playerSize.nameTop);
            groupElements.push(nameText);
        }
        
        const player = new Group(groupElements, {
            custom: {
                type: 'player',
                subType: 'player',
                id: uuidv4(),
                team: colors.name, 
                size,
                ...customData
            },
            originX: 'center',
            originY: 'center',
            left: posX,
            top: posY,
            hasBorders: false,
            hasControls: true
        });

        // In Fabric v6, addWithUpdate() is removed - groups auto-update their dimensions

        onComplete && onComplete(canvas, player);
    });
};

createPlayer.propTypes = {
    canvas: PropTypes.object.isRequired,
    clipart: PropTypes.string.isRequired,
    colors: PropTypes.object.isRequired,
    posX: PropTypes.number.isRequired,
    poxY: PropTypes.number.isRequired,
    playerNumber: PropTypes.string.isRequired,
    team: PropTypes.string.isRequired,
    onComplete: PropTypes.func
};

export default Player;